import { memo, forwardRef } from 'react';
import classNames from 'classnames/bind';

import InnerTable from './InnerTable';

import data from '../../../../data/homepage/tableData';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const TableComponent = forwardRef(({ fixedTableHead }, ref) => (
  <>
    <div className={Styles.table_wrapper} ref={ref}>
      <div className={cx('tablehead_holder', { fixedTableHead })}>
        <h3 className={cx('title', 'text-uppercase')}>How CityFALCON is Better</h3>
        <table className={cx('table_header')}>
          <thead>
            <tr>
              <th />
              <th>CityFALCON</th>
              <th>
                Yahoo Finance,
                {' '}
                <br />
                Google Finance
              </th>
              <th>Twitter only</th>
              <th>Premium Subscription Services</th>
            </tr>
          </thead>
        </table>
      </div>
      {data.map((table, i) => (
        <InnerTable data={table} key={i} />
      ))}
    </div>
    <span>* We are adding new pieces of content on a regular basis</span>
  </>
));

export default memo(TableComponent);
